import React from "react";
import { BUSINESS_INFO } from "../config";

export function ServiceCard({ service }) {
  if (!service) return null;

  const {
    title,
    dog_size,
    price,
    duration,
    description,
    special_info,
    cta_text = "Book tid",
  } = service;

  // Check if special_info is already included in description to prevent duplicate text
  const cleanDesc = (description || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").toLowerCase();
  const cleanInfo = (special_info || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").toLowerCase();
  const isDuplicate = cleanInfo && cleanDesc.includes(cleanInfo);

  return (
    <div className="flex flex-col justify-between rounded-2xl border border-neutral-200 bg-white p-6 sm:p-7 shadow-[0_2px_12px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.06)] transition-shadow duration-300">
      <div>
        {/* Title matching homepage cards */}
        <h3 className="font-heading text-xl sm:text-2xl font-medium text-black">
          {title}
        </h3>

        {/* Description (RichText HTML or text) */}
        {description && (
          <div
            className="mt-3.5 space-y-2.5 text-sm leading-relaxed text-neutral-600 font-normal [&>p]:leading-relaxed [&>p]:mb-2.5 last:[&>p]:mb-0 [&>p:first-of-type]:text-neutral-800 [&_strong]:font-medium [&_strong]:text-black [&>ul]:list-disc [&>ul]:pl-4 [&>ul]:space-y-1.5 [&>ul>li]:text-neutral-600"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}

        {/* Special Info note if present */}
        {special_info && !isDuplicate && (
          <p className="mt-2 text-xs text-neutral-600 leading-relaxed italic">
            {special_info}
          </p>
        )}

        {/* Price & Duration matching homepage cards */}
        <div className="mt-5 pt-3.5 border-t border-neutral-100">
          <span className="text-xl font-bold text-black font-heading block">
            {price && !price.toLowerCase().startsWith("fra") && !price.toLowerCase().includes("afhænger") ? `Fra ${price}` : price}
          </span>
          <span className="text-xs text-neutral-600 block mt-0.5">
            {duration ? `Varighed: ${duration}` : ""}
            {duration && dog_size ? " · " : ""}
            {dog_size ? `${dog_size}` : ""}
          </span>
        </div>
      </div>

      {/* Booking CTA Button */}
      <div className="mt-6 pt-2 flex flex-col gap-2.5">
        <a
          href={BUSINESS_INFO.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-[#dabeb9] px-5 py-3 text-xs sm:text-sm font-medium tracking-wide text-black transition-colors hover:bg-[#c9a7a0]"
          aria-label={`Book tid til ${title}`}
        >
          <i className="fa-solid fa-calendar-check text-black" aria-hidden="true" />
          <span>{cta_text || "Book tid"}</span>
        </a>
      </div>
    </div>
  );
}
